import { render, staticRenderFns } from "./AttributeDetails.vue?vue&type=template&id=11ae7998&scoped=true"
import script from "./AttributeDetails.vue?vue&type=script&lang=js"
export * from "./AttributeDetails.vue?vue&type=script&lang=js"
import style0 from "./AttributeDetails.vue?vue&type=style&index=0&id=11ae7998&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ae7998",
  null
  
)

export default component.exports